import { render } from "./sidebar-with-signature-form.vue?vue&type=template&id=a20fbaa0"
import script from "./sidebar-with-signature-form.vue?vue&type=script&lang=js"
export * from "./sidebar-with-signature-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__